<template>
    <div class="studentClass publicViewClass">
         <div class="show_container">
             <div class="staff_manage_head flex  align-cen">
                <div class="add_btn" @click="addStudentClass">
                    <div class="add_btn_icon" style="width:0"></div>
                    <span> <span class="icon-al-plus"></span>新增分类</span>
                </div>
                   <div class="search_box mft">
                     <el-input placeholder="请输入分类名称" v-model="search" clearable> </el-input>
                </div>
                <div class="public-btn-small flex align-cen" style="padding-left:20px">
                    <div class="public-btn-small-primary"  @click="gethisList">搜索</div>
                    <div class="public-btn-small-text" @click="reset">重置筛选条件</div>
                </div>
             </div>
              <div class="staff_manage_center">
                 <div class="public-list-container">
                    <div class="public-list-container-table">
                        <div class="public-list-container-table-header flex align-cen">
                            <div class="stclass pustclass">分类</div>
                            <div class="stsort pustclass">排序</div>
                            <div class="stcz pustclass">操作</div>
                        </div>
                           <div v-if="itemList.length">
                        <div class="public-list-container-table-row flex align-cen"
                        v-for="(item,index) in itemList"
                        >
                              <div class="stclass pustclass">
                                <p class="stclass-name">{{item.name}}</p>
                                <p v-if="item.name == '未分类' || item.id == 1" class="isname">系统预设分类，不可编辑和删除</p>
                                <!-- {{item.roleName}} -->
                              </div>
                            <div class="stsort pustclass">
                                {{item.sort}}
                            </div>
                            <div class="stcz pustclass">
                                <div class="stcz-btn" v-if="item.name == '未分类' || item.id == 1">
                                  <el-button type="text" style="color:#0157ff;cursor: not-allowed;">禁止操作</el-button> 
                                </div>
                                <div class="stcz-btn" v-else>
                                        <el-button type="text" style="color:#0157ff" @click.stop="editPro(item)">编辑</el-button> 
                                     <el-button type="text" style="color:red" @click.stop="deletPro(item)">删除</el-button> 
                                </div>
                                <!-- {{item.description}} -->
                            </div>
                        </div>
                        </div>
                        <div v-else class="no-empry">
                            暂无数据
                        </div>
                    </div>
                 </div>
                 <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
              </div>
         </div>
      <!-- 增加修改弹窗 -->
      <el-dialog
  :title="tit"
  :visible.sync="centerDialogVisible"
  width="30%"
  :append-to-body="true"
  center>
   <div class="forminfo"
    v-loading="loading"
      element-loading-text="正在添加中..."
     element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
   >
    <el-form :model="formLabelAlign" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
         <el-form-item label="分类名称：" prop="name">
              <el-input v-model="formLabelAlign.name" clearable placeholder="20字以内" class="bbb"></el-input>
        </el-form-item>
         <el-form-item label="排序：">
              <el-input v-model.number="formLabelAlign.sort" clearable class="bbb" minlength="0" maxlength="5"></el-input>
        </el-form-item>
    </el-form>
     <div class="btn" @click="onsubmit('ruleForm')">确定</div>
   </div>
</el-dialog>
    </div>
</template>
<script>
import { getStudentClass,editStudentClass,delestudenttList} from "@/api/enterprise/index"; // 学员分类,新增修改学员分类、删除学员分类
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import debounce from '../../../utils/debounce.js' //防抖
export default {
    name:'studentClass',
    components:{
      paginaTion
    },
    data() {
        return {
        editid:'',
        tit:'',
        edittype:0,
        loading:false,
        centerDialogVisible:false,
         search:'',
         currentPage: 1, //初始页
          PageSize: 10, //每页的数据
          totalCount:0,
          itemList:[],  
          bussID:'',
          formLabelAlign:{
            name:'',
            sort:'',
            businessId:'',
            id:''
          },
          rules: {
             name: [
             { required: true, message: '请正确填写分类名称', trigger: 'blur' },
             { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
          ],
        }
        }
    },
    created () {
          const businessInfo = this.$locaStorage.setAge().get('businessInfo')
         this.bussID = businessInfo.id
         this.gethisList()
    },
    methods: {
        // 新增学员分类
        addStudentClass(){
            this.edittype = 0  //0表示新增项目，1表示修改项目
           this.tit = "新增学员分类"
           this.centerDialogVisible = true 
           this.formLabelAlign = {
            name:'',
            sort:'',
            businessId:this.bussID,
            id:''
           }
           if(this.$refs['ruleForm']){
           this.$refs['ruleForm'].clearValidate();
         }
        },
        // 修改学员分类
        editPro(data){
            this.edittype = 1  //0表示新增项目，1表示修改项目
           this.tit = "修改学员分类"
           this.centerDialogVisible = true 
           this.formLabelAlign = {
            name:data.name,
            sort:data.sort,
            id:data.id,
             businessId:this.bussID,
           }
               if(this.$refs['ruleForm']){
           this.$refs['ruleForm'].clearValidate();
         }
        },
        // 删除学员
        deletPro(data){
            this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            delestudenttList({
              id:data.id,
              },'delete')
                .then(res => {
                 this.$util.Notifi('删除成功','success','fa-check')
                 this.gethisList()
              })
              .catch(err => {
              })
        })
        },
          // 确定
        onsubmit(formName){
             this.$refs[formName].validate((valid) => {
             let params = {};
             let method = "post"
            if(this.edittype == 0)  params = {...this.formLabelAlign},method = "post";
            if(this.edittype == 1)  params = {...this.formLabelAlign},method = "put";
             if(valid){
                if(typeof(this.formLabelAlign.sort) == 'string' && this.formLabelAlign.sort != "") return this.$message.error('排序只能输入数字')
                 //防抖提交
                debounce(() => {
                    this.commentBness(params,method)
                }, 500)
             }
             })
        },
        commentBness(params,method){
             this.loading = true
              editStudentClass(params,method,'enterprise')
                        .then(res => {
                            this.loading = false
                           if(res.code == 0){
                            if(this.edittype == 0) this.$message.success('新增成功'); 
                           if(this.edittype == 1) this.$message.success('修改成功'); 
                                this.gethisList()
                                    setTimeout(() => {
                                this.centerDialogVisible = false
                                }, 100);
                           }else{
                            this.$message.error(res.msg)
                           }
                        })
                        .catch(err => {
                          this.loading = false
                        })
        },
                    // 子组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.gethisList()
      },
        reset(){
              this.search = ''
            this.currentPage1 = 1
            this.gethisList()
        },
          gethisList(){
             let params = {
                name:this.search,
                businessId:this.bussID,
                size:this.PageSize,
                current:this.currentPage,
            }
            getStudentClass(params,'enterprise') 
            .then(res =>{
               this.itemList = res.data.records
            this.totalCount = res.data.total
            })
            .catch(err =>{})
        },
    },
}
</script>
<style lang="scss" scoped>
.add_btn .add_btn_icon{ 
    background: none !important;
}
.public-list-container{
    position: relative;
    .public-list-container-table{
        .public-list-container-table-header{
          .pustclass{
            width: 33.3%;
            text-align: center;
          }
        }
        .public-list-container-table-row {
            padding: 10px 0 !important;
              .pustclass{
            width: 33.3%;
            text-align: center;
            .isname{
                color: #666;
                font-size: 13px;
            }
          }
        }
    }
}
.forminfo{
     .btn{
    width: 80%;
    height: 50px;
    background-color: #409eff;
    border-radius: 0.1vh;
    border: none;
    color: #fff;
    margin: 20px auto;
    margin-bottom: 0;;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
     }
}
::v-deep{
        .el-input__inner{
            height: 30px !important;
            line-height: 30px !important;
        }
        .el-input__icon{
            line-height: 30px;
        }
    .jiange{
        padding-bottom: 20px;
        margin-right: 10px;
    }
}
</style>